<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <form @submit.prevent="changeWonPipeline" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('pipelines.wonDate') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                  </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText /> 
            <p class="text-center" style="font-size: 15px;">{{ $t('pipelines.label.won_text') }}</p>
            <InputDate2
              id="won-date"
              containerClass="col-12 col-md-12 mt-2 mb-2"
              name="pipelines-date_end"
              :label="$t('date')"
              labelClass="form-label"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="false" size="lg"
              v-model="formWonData.date"
              placeholder="JJ-MM-AAAA"
              dateFormat="dd-MM-yyyy"
            />
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingWon"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>

  import { ref, defineProps, watch } from "vue";
  import {useStore} from "vuex";
  import InputDate2 from "@/components/InputDate2.vue"
  import Button from "@/components/Button.vue"
  import i18n from "@/plugins/i18n";
  import {useRoute} from "vue-router";
  import RequiredText from "@/components/RequiredText.vue"
  import {formatTodayDate} from "@/mixins/Helpers"

  const store = useStore()
  const route = useRoute()

  const emits = defineEmits(['load'])

  const props = defineProps({
    id: {
        type: String,
        required: true
    },

    date : {
      type : String,
      required : false
    }
  })

  const formWonData = ref({
    opportunity_id: route.params.id,
    status: 'WON',
    date: props.date ?? formatTodayDate()
  })
  const isLoadingWon = ref(false)

  function changeWonPipeline(){
    isLoadingWon.value = true
    store.dispatch('pipelines/wonPipeline', formWonData.value)
        .then(res => {
          emits('load')
          closeModal()
          isLoadingWon.value = false
          window.toastr['success'](i18n.global.t("notification.status_changed"))
        })
        .catch((err) => {
          isLoadingWon.value = false

        })
  }

  function closeModal(){
    $('#wonModal').modal('toggle')
  }

</script>

<style scoped></style>
